module.exports = __webpack_public_path__ + "img/2cbea54fe4b359e1351a89b0cd66e927.a0644b56.png";